var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicOff = function SvgMicOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6674 12.552L1.72461 3.60915L3.61023 1.72353L30.2769 28.3902L28.3913 30.2758L22.5416 24.4261C21.0662 25.573 19.2817 26.341 17.3341 26.5838V27.9997H21.3341V30.6663H10.6674V27.9997H14.6674V26.5838C9.40566 25.9277 5.33408 21.4392 5.33408 15.9997V13.333H8.00074V15.9997C8.00074 20.418 11.5825 23.9997 16.0007 23.9997C17.7285 23.9997 19.3284 23.452 20.6361 22.5207L18.71 20.5946C17.916 21.0638 16.9898 21.333 16.0007 21.333C13.0552 21.333 10.6674 18.9452 10.6674 15.9997V12.552ZM16.6915 18.576C16.4712 18.6349 16.2396 18.6663 16.0007 18.6663C14.528 18.6663 13.3341 17.4724 13.3341 15.9997V15.2186L16.6915 18.576ZM18.6674 6.66634V13.0474L21.3341 15.7141V6.66634C21.3341 3.72082 18.9463 1.33301 16.0007 1.33301C13.5492 1.33301 11.4839 2.98714 10.8602 5.24021L13.3341 7.71406V6.66634C13.3341 5.19358 14.528 3.99968 16.0007 3.99968C17.4735 3.99968 18.6674 5.19358 18.6674 6.66634ZM25.812 20.192L23.7217 18.1017C23.9037 17.4319 24.0007 16.7271 24.0007 15.9997V13.333H26.6674V15.9997C26.6674 17.488 26.3626 18.9051 25.812 20.192Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MicOff.bdd6e3bd.svg";
export { ForwardRef as ReactComponent };